<script setup lang="ts">
/**
 * ProblemSection —— 教学问题单卡（F12，type=problem，1 卡 = 1 Section）。
 *
 * `GridCard` 渲染标题 + summary 摘要 + 「更多+」（`<DetailMoreLink>`，
 * bodyHtml 非空才渲染，跳 `/detail/:sectionId/:slug?`）。首页卡片摘要
 * 形态，不渲染 bodyHtml 全文（详情页四分区消费）。
 *
 * 区容器（标题 tab + 图标 + `.scu-grid`）由 HomePage `<GroupSection>`
 * 提供，本组件只渲染单张 `.scu-grid-item` 卡。根 `data-section-type`
 * 经 `GridCard` → `GridItem` fallthrough 附到 `<article>` 根。
 */
import GridCard from './GridCard.vue';
import type { SectionComponentProps } from './section-props';

const props = defineProps<SectionComponentProps>();
</script>

<template>
  <GridCard
    :data-section-type="props.section.type"
    :title="props.section.title"
    :summary="props.section.summary"
    :show-draft-badge="props.showDraftBadge"
  >
  </GridCard>
</template>
